
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import './index.css'

// Windows DPI scaling fix: counteract 125%, 150% etc. scaling
// Only targets fractional ratios (1.25, 1.5) — skips Retina (2x) and mobile
const dpr = window.devicePixelRatio || 1;
if (dpr > 1 && dpr < 2 && !('ontouchstart' in window)) {
    document.documentElement.style.zoom = `${1 / dpr}`;
}

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </React.StrictMode>,
)
